import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 rounded-t-2xl mx-4 md:mx-6 mt-20">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <h3 className="text-xl font-heading font-semibold mb-4">GTBuySheet</h3>
            <p className="text-sm text-foreground-200 leading-relaxed">
              Your ultimate resource for spreadsheet automation systems designed for modern buying agents and e-commerce entrepreneurs.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                Home
              </Link>
              <Link to="/article/gtbuy-spreadsheet-guide" className="text-sm text-foreground-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                GTBuy Spreadsheet Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                KASpreadsheet
              </a>
              <Link to="/article/kakobuy-vs-superbuy-vs-gtb-uy-comparison" className="text-sm text-foreground-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                Platform Comparison
              </Link>
              <Link to="/article/shopping-guide-kaspreadsheet" className="text-sm text-foreground-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                Shopping Guide
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">Top Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">Stay Updated</h4>
            <p className="text-sm text-foreground-200 mb-4 leading-relaxed">
              Get the latest spreadsheet tips and automation guides delivered to your inbox.
            </p>
            <form
              id="newsletter-form"
              data-readdy-form=""
              action="https://readdy.ai/api/form/d92ecvlpggnemm8f9sng"
              method="POST"
              className="flex gap-0"
            >
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                required
                className="flex-1 px-4 py-2.5 bg-foreground-800 text-background-50 text-sm rounded-l-full outline-none placeholder:text-foreground-300 border border-foreground-700 focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="spam-guard"
              />
              <button
                type="submit"
                className="w-11 h-11 flex items-center justify-center bg-primary-500 text-background-50 rounded-full -ml-2 cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700/40 px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-foreground-300">
          &copy; {new Date().getFullYear()} GTBuySpreadsheet.work — All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <Link to="/" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
            Privacy Policy
          </Link>
          <Link to="/" className="text-xs text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
            Terms of Service
          </Link>
        </div>
      </div>

      <div className="px-6 md:px-10 pb-8">
        <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-700/20 select-none whitespace-nowrap overflow-hidden">
          GTBUYSPREADSHEET.WORK
        </p>
      </div>
    </footer>
  );
}